// Filter options for calendar views, shared by web and mobile. Passed to
// `useTasksByFilterDocument` when the caller needs timeblocked entries
// rendered alongside real tasks (GoalTimeslot, LifeAreaTimeslot).
export const calendarFilterOptions = {
  includeTaskWithAction: true,
} as const;
